jQuery(document).ready(function () {
  jQuery(".next").on("click", function () {
    var currentImg = jQuery(".active");
    var nextImg = currentImg.next();

    if (nextImg.length) {
      currentImg.removeClass("active").css("z-index", -10);
      nextImg.addClass("active").css("z-index", 10);
    }
  });

  jQuery(".prev").on("click", function () {
    var currentImg = jQuery(".active");
    var prevImg = currentImg.prev();

    if (prevImg.length) {
      currentImg.removeClass("active").css("z-index", -10);
      prevImg.addClass("active").css("z-index", 10);
    }
  });

  $(".back-to-top").click(function () {
    // Klick auf den Button
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      800
    );
    return false;
  });

  // Der Button wird ausgeblendet
  $(".back-to-top").hide();

  // Funktion für das Scroll-Verhalten
  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        // Wenn 100 Pixel gescrolled wurde
        $(".back-to-top").fadeIn();
      } else {
        $(".back-to-top").fadeOut();
      }
    });

    $(".back-to-top").click(function () {
      // Klick auf den Button
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        800
      );
      return false;
    });
  });

  /* Search Menu */

  $(".search-icon").click(function () {
    $(".wpbsearchform").slideToggle("fast");
  });

  $(document).keyup(function (e) {
    if (e.key == "Escape") {
      $(".wpbsearchform").hide();
    }
  });
});

/*
 * Barrierefreiheit: falsche ARIA-Rollen der slick-Slider entfernen.
 * Dev-Briefing KW 33.1, Punkt 7.
 *
 * slick zeichnet den Track als role="listbox" und die Slides als role="option"
 * aus, die Punktnavigation als role="tablist" mit role="presentation"-Kindern,
 * die zugleich aria-selected und aria-controls tragen. Ein Slider ist aber kein
 * Auswahlfeld: Screenreader kuendigen ein namenloses Auswahlfeld mit namenlosen
 * Optionen an. Vier axe-Verstoesse aus einer Ursache.
 *
 * Die Rollen werden entfernt statt korrigiert - das ist die robustere Variante,
 * weil slick Slides klont und die Attribute bei jedem Wechsel neu setzt.
 * Deshalb laeuft die Bereinigung auch nach jedem slick-Event erneut.
 */
(function ($) {
  "use strict";

  function slickRollenBereinigen(kontext) {
    var $k = kontext && kontext.length ? kontext : $(document);

    $k.find(".slick-track").each(function () {
      var $track = $(this);
      // Traegt der Track li-Kinder, braucht er role="list" - sonst stehen die
      // Listenpunkte ohne Listen-Elternteil da (axe: listitem). Ein ersatzloses
      // Entfernen der Rolle reicht hier also nicht.
      if ($track.children("li").length) {
        $track.attr("role", "list");
      } else {
        $track.removeAttr("role");
      }
    });

    $k.find(".slick-slide")
      .removeAttr("role")
      .removeAttr("aria-selected")
      // slick setzt aria-controls auf IDs, die es nie anlegt ("navigation10").
      // Ein Verweis ins Leere ist ein ungueltiger Attributwert
      // (axe: aria-valid-attr-value).
      .removeAttr("aria-controls");

    // slick versteckt inaktive Slides per aria-hidden, laesst die Links darin
    // aber im Tabfluss - fuer Screenreader-Nutzer ein Sprung ins Nichts
    // (axe: aria-hidden-focus). Der Fokus wird deshalb mitgenommen: in
    // versteckten Slides raus, in sichtbaren wieder rein.
    $k.find('.slick-slide[aria-hidden="true"]')
      .find('a, button, input, select, textarea, [tabindex]')
      .attr("tabindex", "-1");

    $k.find('.slick-slide[aria-hidden="false"], .slick-slide.slick-active')
      .find('a, button, input, select, textarea')
      .removeAttr("tabindex");

    // Die Punktnavigation: slick gibt ihr role="tablist" mit
    // role="presentation"-Kindern - ein Slider ist aber keine Registerkarten-
    // leiste. Die Rolle wird ersatzlos entfernt statt durch "group" ersetzt:
    // ein ul ist von sich aus eine Liste, und mit role="group" verliert es
    // genau diese Bedeutung, wodurch seine li ohne Listen-Elternteil dastehen
    // (axe: listitem). Der Name kommt ueber aria-label, das an einer Liste
    // erlaubt ist.
    $k.find(".slick-dots")
      .removeAttr("role")
      .attr("aria-label", "Bildauswahl");

    // aria-hidden an den Punkten ist schlicht falsch: sie sind sichtbar,
    // bedienbar und enthalten je einen Button im Tabfluss - fuer axe ein
    // versteckter Bereich mit fokussierbarem Inhalt (aria-hidden-focus).
    $k.find(".slick-dots li")
      .removeAttr("role")
      .removeAttr("aria-selected")
      .removeAttr("aria-controls")
      .removeAttr("aria-hidden");
  }

  /*
   * slick schreibt die Rollen in initADA() synchron waehrend init und reInit.
   * Wuerde hier direkt bereinigt, liefe das je nach Reihenfolge VOR slick und
   * waere sofort wieder ueberschrieben - genau das war beim ersten Versuch der
   * Fall. Das setTimeout schiebt die Bereinigung ans Ende der Aufgabenschlange
   * und damit sicher hinter slick.
   */
  function spaeterBereinigen(kontext) {
    window.setTimeout(function () {
      slickRollenBereinigen(kontext);
    }, 0);
  }

  /*
   * WCAG 2.2.2: Automatisch bewegte Inhalte brauchen einen Mechanismus zum
   * Pausieren. Beide Slider auf der Startseite laufen automatisch (6 Slides alle
   * 20 s, 3 Slides alle 7,2 s), der zweite ohne jede Steuerung. Die Punkte
   * wechseln den Slide, halten ihn aber nicht an; pauseOnHover greift bei
   * Tastatur und Touch nicht.
   *
   * Der Schalter wird hier erzeugt statt in den Templates, damit er automatisch
   * fuer jeden Slider mit autoplay gilt - auch fuer spaeter hinzugekommene.
   *
   * Bis 11.09.2026 war der Schalter bis zum Tastaturfokus unsichtbar. Der
   * Accessibility-Bericht KW 37.1 verlangt einen fuer alle sichtbaren
   * Mechanismus; seitdem ist er ein runder Knopf rechts unten im Slider mit
   * Pause- bzw. Play-Symbol (Inline-SVG, unabhaengig von den Icon-Schriften),
   * Tooltip und Text fuer Screenreader. Fuer Nutzer mit prefers-reduced-motion
   * steht der Slider von vornherein still.
   *
   * Der Knopf steht als Geschwister VOR dem Slider, nicht darin: slick baut
   * bei Breakpoint-Wechseln neu auf und wuerde jedes Kind des Sliders fuer
   * einen Slide halten. Positioniert wird er absolut zum Elternelement; ist
   * das nicht positioniert, bekommt es die Klasse slider-toggle-anker.
   */
  var TEXT_PAUSE = "Automatischen Bildwechsel pausieren";
  var TEXT_WEITER = "Automatischen Bildwechsel fortsetzen";
  var ICON_PAUSE =
    '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14">' +
    '<rect x="2" y="1" width="3.5" height="12" rx="1"></rect>' +
    '<rect x="8.5" y="1" width="3.5" height="12" rx="1"></rect></svg>';
  var ICON_PLAY =
    '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14">' +
    '<path d="M3.5 1.5v11l9-5.5z"></path></svg>';

  function pauseSchalterZustand($btn, pausiert) {
    var text = pausiert ? TEXT_WEITER : TEXT_PAUSE;
    $btn
      .attr("aria-pressed", String(pausiert))
      .attr("title", text)
      .html((pausiert ? ICON_PLAY : ICON_PAUSE) + '<span class="sr-only"></span>');
    $btn.find(".sr-only").text(text);
  }

  function pauseSchalterErgaenzen($slider) {
    if ($slider.data("ppPauseSchalter")) return;

    var slick = null;
    try {
      slick = $slider.slick("getSlick");
    } catch (e) {
      return;
    }
    if (!slick || !slick.options || !slick.options.autoplay) return;

    $slider.data("ppPauseSchalter", true);

    var $btn = $("<button>", {
      type: "button",
      "class": "slider-toggle",
    });
    pauseSchalterZustand($btn, false);

    // Beim Hero sitzt der Knopf auf Hoehe der Punktnavigation.
    if ($slider.find(".slick-dots").length) {
      $btn.addClass("slider-toggle--punkte");
    }

    var $anker = $slider.parent();
    if ($anker.length && $anker.css("position") === "static") {
      $anker.addClass("slider-toggle-anker");
    }

    $btn.on("click", function () {
      var pausiert = this.getAttribute("aria-pressed") === "true";
      $slider.slick(pausiert ? "slickPlay" : "slickPause");
      pauseSchalterZustand($btn, !pausiert);
    });

    $slider.before($btn);

    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      $slider.slick("slickPause");
      pauseSchalterZustand($btn, true);
    }
  }

  /*
   * Der Facettenfilter der Kliniksuche besteht aus <a role="button"> ohne href
   * und ohne tabindex. Gemessen: 378 Optionen, davon 0 fokussierbar - der
   * Filter ist per Tastatur also gar nicht bedienbar (WCAG 2.1.1, Level A).
   * Ein role="button" allein bringt das Element nicht in den Tabfluss, und ohne
   * href reagiert es auch nicht auf Enter.
   *
   * Hier zentral statt in den fuenf Templates, weil ein Teil dieser Anker erst
   * von dropdown.js erzeugt wird (dl-back, dl-parent) und dort ohnehin nicht
   * erfasst waere.
   */
  function tastaturbedienungNachruesten(kontext) {
    var $k = kontext && kontext.length ? kontext : $(document);
    $k.find('a[role="button"]:not([href]):not([tabindex])').attr("tabindex", "0");
  }

  $(document).on("keydown", 'a[role="button"]:not([href])', function (e) {
    // Native Buttons reagieren auf Enter und Leertaste; das muss hier
    // nachgebildet werden. Leertaste zusaetzlich abfangen, damit die Seite
    // nicht wegscrollt.
    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
      e.preventDefault();
      $(this).trigger("click");
    }
  });

  function alleSliderMitPauseVersehen() {
    $(".slick-initialized").each(function () {
      pauseSchalterErgaenzen($(this));
    });
  }

  $(function () {
    spaeterBereinigen();
    tastaturbedienungNachruesten();
    window.setTimeout(alleSliderMitPauseVersehen, 0);
    $(window).on("load", function () {
      window.setTimeout(alleSliderMitPauseVersehen, 0);
      // dropdown.js baut Teile des Filters erst nach dem Laden auf.
      tastaturbedienungNachruesten();
    });

    // Die Slider werden teils in eigenen <script>-Bloecken in den Templates
    // initialisiert, also moeglicherweise nach diesem Handler. Deshalb zusaetzlich
    // nach dem vollstaendigen Laden noch einmal.
    $(window).on("load", function () {
      spaeterBereinigen();
    });

    $(document).on(
      "init reInit setPosition afterChange breakpoint",
      ".slick-slider, .slick-initialized",
      function () {
        spaeterBereinigen($(this));
      }
    );
  });
})(jQuery);
